export function fondsSpecification(fondsen, currentFonds) {
    let specs;
    specs = fondsen ? fondsen
        .filter(fonds => fonds.fonds !== currentFonds)
        .map(fonds => `${fonds.fonds} (€ ${fonds.beleggingen.toLocaleString('nl-NL')}.000)`) : [];
    return specs.join(', ');
}
